/**
 * Copyright 2026 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import { Actionable, Icon, Text } from '@az/starc-ui';
import { Close, Locator } from '@az/starc-ui-icons';
import styles from './StoreLocationPrompt.module.scss';
import { useLabels } from '@/hooks/useLabels';

const labelMap = {
  rightStoreAlert: 'label_rightStoreAlert',
  closeStorePrompt: 'label_topnav_closeStorePrompt',
};

type Props = {
  onClose: () => void;
  onStoreClick: () => void;
};

export function StoreLocationPrompt({ onClose, onStoreClick }: Props) {
  const labels = useLabels(labelMap);

  return (
    <div className={styles.container}>
      <Icon svg={Locator} color="accent" size={{ s: 7, m: 8 }} />
      <Actionable onClick={onStoreClick} className={styles.promptText}>
        <Text weight="bold" variant="large-body" lineHeight="140" className={styles.promptLabel}>
          <span id="store-location-prompt-label">{labels.rightStoreAlert}</span>
        </Text>
      </Actionable>
      <Actionable onClick={onClose} className={styles.closeButton}>
        <Icon svg={Close} size={7.5} color="600" />
        <span className={styles.srOnly}>{labels.closeStorePrompt}</span>
      </Actionable>
    </div>
  );
}
